import React from 'react'
import { Popover } from 'antd'

import { MODIFIER_KEY } from '../utils/linkClick'
import './ContentTips.css'

/**
 * 内容列的书写规则说明
 *
 * 内容单元格是纯文本编辑，渲染规则全部靠「行的开头」判断，
 * 所以这些技巧不写出来用户很难发现。规则本体见 utils/richText.js 的 formatText。
 */
const TIPS = [
    {
        title: '整行写链接',
        sample: 'https://example.com/doc',
        desc: `以 http 开头且单独占一行，会自动渲染成可点击的链接。编辑区里裸点击只放光标，按住 ${MODIFIER_KEY} 点击才会新标签页打开，避免编辑时误触。`,
    },
    {
        title: '行首写 TODO',
        sample: 'TODO 补上接口文档',
        desc: '以 todo 开头的行（不区分大小写）会整行高亮成待办样式，方便回顾时快速扫到没做完的事。',
    },
    {
        title: '一行一件事',
        sample: '看完第三章\n跑通本地环境',
        desc: '换行会原样保留，每行独立判断样式。链接和 TODO 都只认行首，写在句子中间不会生效。',
    },
    {
        title: '粘贴会保留结构',
        sample: null,
        editOnly: true,
        desc: '从网页或文档粘贴时会自动转成纯文本，只保留换行，不带来源的字体和颜色。',
    },
]

function TipsContent({ editable }) {
    const tips = editable ? TIPS : TIPS.filter(tip => !tip.editOnly)

    return (
        <div className="content-tips-panel">
            <div className="content-tips-title">内容怎么写</div>
            {tips.map(tip => (
                <div className="content-tips-item" key={tip.title}>
                    <div className="content-tips-item-title">{tip.title}</div>
                    {tip.sample && <pre className="content-tips-sample">{tip.sample}</pre>}
                    <div className="content-tips-desc">{tip.desc}</div>
                </div>
            ))}
            {editable && (
                <div className="content-tips-footer">
                    {MODIFIER_KEY} + S 保存，Esc 切换打码
                </div>
            )}
        </div>
    )
}

function ContentTips({ editable = false }) {
    return (
        <Popover
            content={<TipsContent editable={editable} />}
            trigger={['hover', 'click']}
            placement="bottomLeft"
            overlayClassName="content-tips-popover"
        >
            <button
                type="button"
                className="content-tips-trigger"
                aria-label="内容书写说明"
                onClick={e => e.preventDefault()}
            >
                ?
            </button>
        </Popover>
    )
}

export default ContentTips
